import { useOutletContext } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { useElectricityData } from "api/electricity";

import ElectricityGraph from "components/ElectricityGraph";
import ElectricityConsumption from "components/ElectricityConsumption";
import ElectricityEarnings from "components/ElectricityEarnings";
import ExchangeRateOutput from "components/ExchangeRateOutput";

export default function ElectricityData() {
  const { user } = useAuth0();

  const [farmName, dayRange] = useOutletContext<any>();

  const { data: electricityData } = useElectricityData(user["https://hasura.io/jwt/claims"]["x-hasura-user-id"], dayRange, farmName);

  return !electricityData ? null : (
    <>
      <div className="mt-5 px-5 lg:px-12 max-w-sm md:max-w-7xl mx-auto grid gap-5 md:grid-cols-2 lg:grid-cols-3 items-start">
        <div className="col-span-2 output-card p-5 md:p-7 w-96 sm:w-auto ">
          <div className="flex-shrink-0 mb-3 text-gray-500 font-bold">Consumption Vs Sold To Grid</div>
          <ElectricityGraph data={electricityData.data} />
        </div>
        <div className="space-y-5">
          <ElectricityConsumption electricityData={electricityData?.total} />
          <ElectricityEarnings electricityData={electricityData?.total} />
        </div>
      </div>
      <ExchangeRateOutput title="APX Electricity" unit="mW" rate={electricityData?.total.price} timestamp={electricityData?.total.timestamp} />
    </>
  );
}
